import { Component, ViewChild, OnDestroy } from '@angular/core';
import { NavController,ViewController,NavParams,Platform,ToastController,AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../../providers/provider';
import { Slides } from 'ionic-angular';

import { productDetailPage } from '../../productDetail/productDetail';
import { CartPage } from '../../cart/cart';
import { CustomizerProvider } from '../../../providers/customizer/customizer';
import { ProductsNoImageListPage } from '../productsNoImageList/productsNoImageList';
import { ProductsWithImageList } from '../productsWithImageList/productsWithImageList';
import { ProductsVerticalPage } from '../productsVertical/productsVertical';
import { Subject } from 'rxjs';

@Component({
  selector: 'page-products-horizontal',
  templateUrl: 'productsHorizontal.html'
})
export class ProductsHorizontalPage implements OnDestroy {
  @ViewChild(Slides) slides: Slides;
  url: any;
  groupId = '';
  groupContentId = '';
  viewType = 'no-list-image';
  groupContent: any;
  group: any;
  data: any;
  tot = 0;
  width: any;
  height: any;
  qty = 1;
  private _onDestroy = new Subject();
  variants = [];
  ingredients = [];
  elements = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public toastCtrl: ToastController,
              public viewCtrl: ViewController,
              public alertCtrl: AlertController,
              public provider: provider,
              public customizer: CustomizerProvider,
              public platform: Platform) {
    this.url = provider.getUrl();
    this.data = provider.getMenu();
    this.group = navParams.get('group');
    this.groupId = this.group._id;
    this.groupContentId = this.group.content._id;
    this.groupContent = this.group.content;

    this.elements = this.elements.concat(provider.getMenuChildRows(this.groupId))

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
    });

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getUrlImage(img) {
    if(this.data.settings.highResImages) {
      return this.url + img;
    } else {
      return this.url + img + '?w=' + this.width;
    }   
  }

  async element() {
    let i = this.slides.getActiveIndex();
    let element = this.elements[i];
    return element
  }

  show() {
    this.element().then((element) => {
      if(element.contentType == 'Tag') {
        //pubblicità
        let isAdv = this.data.menu.righe.filter((element) => element.parent == element._id);
        if (isAdv.length == 0) return;

        if(element.viewType == 'vertical') 
          this.navCtrl.push(ProductsVerticalPage, { group: element });
        else if(element.viewType == 'horizontal') 
          this.navCtrl.push(ProductsHorizontalPage, { group: element });
        else if(element.viewType == 'image-list') 
          this.navCtrl.push(ProductsWithImageList, { group: element });
        else
          this.navCtrl.push(ProductsNoImageListPage, { group: element });
      } else {
        this.navCtrl.push(productDetailPage, { product: element });
      }
    });
  }

  showProducts(group) {
    
  }

  showProduct(product) {
  }

  cart() {
    this.navCtrl.push(CartPage);
  }
  
  prev() {
    this.slides.slidePrev();
  }

  next() {
    this.slides.slideNext();
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }

  ionViewDidLoad() {
  }

  // check for extended description
  hasExtendedDescription(group) : Boolean {
    return (group.descrizioneEstesa != undefined && group.descrizioneEstesa[0] != undefined && group.descrizioneEstesa[0].contenuto != '');
  }

  readMore(descr) {
    let text;

    text = this.provider.renderDescrEstesa(descr);

    let alert = this.alertCtrl.create({
      title: 'Informazioni',
      message: text,
      buttons: ['OK']
    });
    alert.present();
  }

}




// WEBPACK FOOTER //
// ./src/pages/products/productsHorizontal/productsHorizontal.ts